export class GeneralProfiles {
    constructor(http) {
      this.http = http;
    }

    fetchProfile(profile_id) {
      return this.http.get(`general/profile/${profile_id}/`).then(response => response.data);
    }
  
    fetchGeneralProfiles(filter_by, page, search, is_favorite, page_size, startDate, endDate) {
      return this.http
        .post('general/', { filter_by, page, search, is_favorite, page_size, startDate, endDate })
        .then(response => response);
    }

    fetchGeneralProfileChildren(account_id, startDate = null, endDate = null) {
      return this.http.get(`general/${account_id}/`, {
        params: {
          startDate,
          endDate
        }
      }).then(response => response.data);
    }

    updateGeneralProfile(profile_id, data) {
      return this.http.patch(`general/profile/${profile_id}/`, JSON.parse(JSON.stringify(data))).then(response => response.data);
    }

    sendProfileAction(profile_id, action) {
      return this.http.post(`general/action/${profile_id}/${action}/`);
    }

    createTransfer(data) {
      return this.http.post(
        'general/profile/transfers/', 
        {
          to_user: data.toOperator,
          from_user: null,
          account_id: data.accountId,
          transfer_date: data.transferDate,
          transfer_id: null,
          profile_id: data.profileId
        }
      ).then(response => response.data);
    }

    updateTransfer(data) {
      return this.http.patch(
        `general/profile/transfers/${data.transferId}/`, 
        {
          to_user: data.toOperator,
          from_user: null,
          account_id: data.accountId,
          transfer_date: data.transferDate,
          transfer_id: data.transferId,
          profile_id: data.profileId
        }
      ).then(response => response.data);
    }

    setAccountFavorite(account_id) {
      return this.http.patch(`general/${account_id}/`).then(response => response.data);
    }
  }